import { create } from 'zustand';

export interface Account {
  id: string;
  username: string;
  email: string;
  email_verified: boolean;
  avatar_url: string | null;
  status: string;
  created_at: string;
}

interface AuthState {
  sessionToken: string | null;
  account: Account | null;
  setSession: (token: string, account: Account) => void;
  clearSession: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  (set, get) => ({
    sessionToken: null,
    account: null,

    setSession: (token, account) => {
      set({ sessionToken: token, account });
    },

    clearSession: () => {
      set({ sessionToken: null, account: null });
    },

    isAuthenticated: () => {
      return get().sessionToken !== null && get().account !== null;
    },
  })
);
